<template>
    <div class="progressbar-practice">
        <span class="progressbar-practice__indicator"
            :style="indicatorStyle"></span>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            indicatorPercent: { type: Number, default: 40 },            
        },

        computed: {
            indicatorStyle(){
                let progressbarWidth = 308;
                let indicatorWidth = (progressbarWidth / 100) * this.indicatorPercent;
                return `width: ${indicatorWidth}px;`;
            }
        }
    };
</script>

<style scoped src="@/css/components/progressbar-practice.css"></style>